import { render } from "./MdmMainTable.vue?vue&type=template&id=5510e288&scoped=true"
import script from "./MdmMainTable.vue?vue&type=script&lang=js"
export * from "./MdmMainTable.vue?vue&type=script&lang=js"

import "./MdmMainTable.vue?vue&type=style&index=0&id=5510e288&scoped=true&lang=css"

import exportComponent from "/Users/newuser/Herd/spider-project-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5510e288"]])

export default __exports__